
import { Component, Vue } from 'vue-property-decorator'
import error500 from '@/assets/images/error-page/error-500.svg'
import errorContent from './error-content.vue'

@Component({
    components: {
        errorContent
    }
})
export default class Error500 extends Vue {
    name = 'error_500'
    src = error500
}
